"use client";

import useNewRelicErrorHandler from "shared/hooks/useNewRelicErrorHandler";

export default function NewRelicErrorListener(): null {
  useNewRelicErrorHandler();

  return null;
}
